export default {
  methods: {
    shouldDisplay: function (url) {
      var flag = false
      if (this.$store.state.isUserLoggedIn) {
        var roles = this.$store.state.user.roles
        if (roles) {
          var accesslist = []
          for (var i = 0; i < roles.length; i++) {
            var permissions = roles[i].permissions
            // console.log(permissions)
            if (permissions) {
              for (var j = 0; j < permissions.length; j++) {
                accesslist.push(permissions[j].description)
              }
            }
          }
          if (accesslist) {
            for (var k = 0; k < accesslist.length; k++) {
              if (url === accesslist[k]) {
                flag = true
                break
              }
            }
          }
        }
      }
      return flag
    },
    handleError: function (error) {
      console.log('handleError()--error[' + error + '],error message[' + error.message + ']')
      var errormsg = 'undefined error'
      if (typeof error !== 'undefined') {
        if (typeof error.response !== 'undefined') {
          console.log('handleError()--error reponse[' + error.response + '],error response status[' + error.response.status + ']')
          if (error.response.status === 403) {
            this.$store.dispatch('setToken', null)
            this.$store.dispatch('setUser', null)
            this.$router.push({name: 'loginTimeout'})
          } else {
            if (error.response.data) {
              console.log('handleError()--error reponse[' + error.response + '],error response data error[' + error.response.data.error + ']')
              errormsg = error.response.data.error
            } else {
              if (error.message === 'Network Error') {
                errormsg = 'Network or System Issue. Please Try Again later'
              } else {
                errormsg = error.message
              }
            }
          }
        } else {
          if (error.hasOwnProperty('message')) {
            if (error.message === 'Network Error') {
              errormsg = 'Network or System Issue. Please Try Again later'
            } else {
              errormsg = error.message
            }
          }
        }
      }
      return errormsg
    },
    sessionTimeout: function (error) {
      console.log('sessionTimeout()--caught error[' + error + '],error reponse[' + error.response + '],error message[' + error.message + '],error statuscode[' + error.response.status + ']')
      if ((error === 'SESSION_TIME_OUT') || (error.response.status === 403)) {
        this.$store.dispatch('setToken', null)
        this.$store.dispatch('setUser', null)
        this.$router.push({
          name: 'loginTimeout'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js